function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from "react";
import { Menu, Button, Avatar, Dropdown, Image, Drawer, PageHeader, Descriptions } from "antd";
import { Link, useNavigate } from 'react-router-dom';
import Common from "../includes/Common";
import { Power, HouseFill, Search, CheckCircleFill, HouseDoorFill, CollectionFill, PieChartFill, PeopleFill, GearFill, EarFill, EyeFill, HeartPulseFill, HouseLockFill, Eyedropper } from 'react-bootstrap-icons';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var UserNavBar = function UserNavBar(_ref) {
  var handleMenuClose = _ref.handleMenuClose;
  var navigate = useNavigate();
  var _useState = useState('day'),
    _useState2 = _slicedToArray(_useState, 2),
    current = _useState2[0],
    setCurrent = _useState2[1];
  var handleClick = function handleClick(e) {
    setCurrent(e.key);
    if (e.key == 'quit') {
      axios.post(Common.baseApiUrl + 'sulogout').then(function (response) {
        if (response.data.status == 200) {
          localStorage.clear();
          navigate('/');
        }
      })["catch"](function (error) {});
    }
    handleMenuClose();
  };
  var user = Common.currentUser;
  return /*#__PURE__*/_jsxs(Menu, {
    onClick: handleClick,
    selectedKeys: current,
    mode: "vertical",
    children: [(Common.currentUser.role == 1 || Common.currentUser.role == 6 || Common.currentUser.role == 8 || Common.currentUser.role == 9 || Common.currentUser.role == 7 || Common.currentUser.role == 10 || Common.currentUser.role == 21) && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(HouseFill, {
        size: 26
      }),
      children: /*#__PURE__*/_jsx(Link, {
        to: "/home"
      })
    }, "day"), (Common.currentUser.role == 11 || Common.currentUser.role == 10 || Common.currentUser.role == 9) && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(HouseDoorFill, {
        style: {
          color: '#C3BE5A'
        },
        size: 26
      }),
      children: /*#__PURE__*/_jsx(Link, {
        to: "/home/hs"
      })
    }, "sday"), (Common.currentUser.role == 8 || Common.currentUser.role == 9 || Common.currentUser.role == 7 || Common.currentUser.role == 10 || Common.currentUser.role == 21) && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(CollectionFill, {
        size: 26
      }),
      children: /*#__PURE__*/_jsx(Link, {
        to: "/home/queue"
      })
    }, "queue"), Common.currentUser.role == 10 && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(Search, {
        size: 26
      }),
      children: /*#__PURE__*/_jsx(Link, {
        to: "/home/searchrnc"
      })
    }, "searchcand"), (Common.currentUser.role == 2 || Common.currentUser.role == 6 || Common.currentUser.role == 9 || Common.currentUser.role == 10 || Common.currentUser.role == 21) && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(Eyedropper, {
        size: 26
      }),
      children: /*#__PURE__*/_jsx(Link, {
        to: "/home/processlab"
      })
    }, "processlab"), (Common.currentUser.role == 3 || Common.currentUser.role == 6 || Common.currentUser.role == 9 || Common.currentUser.role == 10 || Common.currentUser.role == 21) && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(HeartPulseFill, {
        size: 26
      }),
      children: /*#__PURE__*/_jsx(Link, {
        to: "/home/processmedecine"
      })
    }, "processmedecine"), (Common.currentUser.role == 4 || Common.currentUser.role == 6 || Common.currentUser.role == 9 || Common.currentUser.role == 10 || Common.currentUser.role == 21) && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(EarFill, {
        size: 26
      }),
      children: /*#__PURE__*/_jsx(Link, {
        to: "/home/processaudio"
      })
    }, "processaudio"), (Common.currentUser.role == 5 || Common.currentUser.role == 6 || Common.currentUser.role == 9 || Common.currentUser.role == 10 || Common.currentUser.role == 21) && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(EyeFill, {
        size: 26
      }),
      children: /*#__PURE__*/_jsx(Link, {
        to: "/home/processvisio"
      })
    }, "processvisio"), (Common.currentUser.role == 3 || Common.currentUser.role == 6 || Common.currentUser.role == 8 || Common.currentUser.role == 9 || Common.currentUser.role == 10 || Common.currentUser.role == 21) && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(CheckCircleFill, {
        style: {
          color: 'green',
          fontWeight: 'bold'
        },
        size: 26
      }),
      children: /*#__PURE__*/_jsx(Link, {
        to: "/home/validate"
      })
    }, "search"), (Common.currentUser.role == 8 || Common.currentUser.role == 7 || Common.currentUser.role == 9 || Common.currentUser.role == 10 || Common.currentUser.role == 21) && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(PieChartFill, {
        style: {
          color: 'FBB91D'
        },
        size: 26
      }),
      children: /*#__PURE__*/_jsx(Link, {
        to: "/home/reports"
      })
    }, "rapports"), (Common.currentUser.role == 9 || Common.currentUser.role == 10) && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(HouseLockFill, {
        style: {
          color: '#EA6A6B'
        },
        size: 26
      }),
      children: /*#__PURE__*/_jsx(Link, {
        to: "/home/rpreports"
      })
    }, "rprapports"), (Common.currentUser.role == 9 || Common.currentUser.role == 10) && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(PeopleFill, {
        style: {
          color: 'FBB91D'
        },
        size: 26
      }),
      children: /*#__PURE__*/_jsx(Link, {
        to: "/home/users"
      })
    }, "users"), /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(GearFill, {
        style: {
          color: 'FBB91D'
        },
        size: 26
      }),
      children: /*#__PURE__*/_jsx(Link, {
        to: "/home/accountconfig"
      })
    }, "accountconfig"), /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(Power, {
        style: {
          color: 'EA696B'
        },
        size: 26
      })
    }, "quit")]
  });
};
export default UserNavBar;